import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-21/task-02";

const task: Slide = {
  titleHtml:
    "Indicate which measures will yield good sound insulation</br>of a window, and which will lead to a bad one.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
